import { ApiResponse, getRequest } from "@/data/apiClient";
import { auth } from "@micad/vue-components";

export interface UserSessionResponse {
  userId: number;
  userName: string;
  sessionId: string;
  expirationTimestamp: string;
  firstName: string;
  lastName: string;
  micadUser: boolean;
  roles: { id: number; name: string }[];
  appRoles: { [key: string]: string };
  myRole?: string;
}

export interface AppOption {
  app: string;
  clientKey: string;
  description: string;
  homeUrl: string;
  icon: string;
  title: string;
}

export async function getUserSession(
  userId = -1,
  app: string | undefined = undefined
): Promise<ApiResponse<UserSessionResponse>> {
  if (userId === -1) userId = parseInt(String(auth.userId || "0"));
  return getRequest("user/session", {
    userId,
    app,
    sessionId: auth.sessionId,
  });
}

export interface clientInfoResponse {
  id: number;
  key: string;
  name: string;
  logoUrl: string;
}

export async function getClientInfo(): Promise<clientInfoResponse> {
  return (await getRequest("client")).payload as clientInfoResponse;
}

export interface AppResponse {
  applications: AppOption[];
}

export async function getApps(): Promise<AppResponse> {
  return (await getRequest("registeredApps")).payload as AppResponse;
}

export async function getIntercomToken(): Promise<string> {
  return (await getRequest("/jwt/intercom")).payload as string;
}